import { destroy, mutate, query, update, download } from "../../defaults/fetch";
import {useState,useEffect} from "react";



// PAYROLL CONFIG
export const useInitializePayroll = ()=>{
    const initializePayroll = async (body)=>{
        const url = `payroll/initialize`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return initializePayroll;
}


export const useSubmitPayroll = ()=>{
    const submitPayroll = async (body)=>{
        const  url = `payroll/submit-payroll`;
        const {message} = await mutate(url,true,body);
        console.log(message)
        return message;
    }
    return submitPayroll;
}


export const useDeletePayroll = ()=>{
    const deletePayroll = async (id)=>{
        const url = `payroll/remove-payroll/${id}`;
        const {message} = await destroy(url);
        return message;
    }

    return deletePayroll;
}


export const usePayrollApproval = ()=>{
    const appprovePayroll = async (body)=>{
        const url = `payroll/approve-payroll`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return appprovePayroll;
}


export const useDisApprovePayroll = ()=>{
    const disapprovePayroll = async (body)=>{
        const url = `payroll/disapprov-payroll`;
        const {message} = await mutate(url,true,body);
        return message;
    }

    return disapprovePayroll;
}


export const useGetPayrollData = ()=>{

    const getPayrollData = async (year,month=1)=>{
        const url = `payroll/get-payroll-data`;
        const qs = {
            page:0,
            size:50,
            year,
            month
        }
        const {data} = await query(url,qs);
        return data;
    }
    return getPayrollData;

}



// ACTUALL PAYROLL

export const useTopPayroll = ()=>{
    const topPayroll = async (body)=>{
        const url = `payroll/top-payroll`;
        const {message} = await mutate(url,true,body);
        return message
    }
    return topPayroll;
}

export const useDeductPayroll = ()=>{
    const deductPayroll = async (body)=>{
        const url = `payroll/deduct-from-payroll`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return deductPayroll;
}

export const useSettleMonthPayroll = ()=>{
    const settlePayroll = async (body)=>{
        const url = `payroll/settle-all-payrolls`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return settlePayroll;
}



// SINGLE USER PAYROLL DATA

export const useCreateSinglePayroll = ()=>{
    const createPayroll = async (body)=>{
        const url = `payroll/create-single-payroll`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return createPayroll;
}


export const useDeleteSinglePayroll = ()=>{
    const deletePayroll = async (id)=>{
        const url = `payroll/delete-payroll/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deletePayroll;
}


export const useSettleUserPayroll = ()=>{
    const settlePayroll = async (body)=>{
        const url = `payroll/settle-payroll`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return settlePayroll;
}

// PAYROLL ADJUSTMENTS
export const useGetAdjustmentHistory = ()=>{
    const getAdjustmentHistory = async (year, month, page = 0, size = 20)=>{
        const url = `payroll/adjustments/history`;
        const qs = {
            year,
            month,
            page,
            size
        }
        const {data} = await query(url, qs);
        return data;
    }
    return getAdjustmentHistory;
}

export const useGetAdjustmentSummary = ()=>{
    const getAdjustmentSummary = async (year, month)=>{
        const url = `payroll/adjustments/summary`;
        const qs = {
            year,
            month
        }
        const {data} = await query(url, qs);
        return data;
    }
    return getAdjustmentSummary;
}

export const useGetPayrollAdjustments = ()=>{
    const getPayrollAdjustments = async (payrollId)=>{
        const url = `payroll/adjustments/${payrollId}`;
        const {data} = await query(url);
        return data;
    }
    return getPayrollAdjustments;
}

// PAYROLL REPORTS
export const useDownloadBeneficiaryReport = ()=>{
    const downloadBeneficiaryReport = async (year, month = null)=>{
        const url = `payroll/reports/beneficiaries/pdf`;
        const qs = month ? { year, month } : { year };
        const filename = month ? `payroll_beneficiaries_${year}_${month}.pdf` : `payroll_beneficiaries_${year}.pdf`;
        await download(url, filename, 'pdf', true, qs);
    }
    return downloadBeneficiaryReport;
}

export const useDownloadSummaryReport = ()=>{
    const downloadSummaryReport = async (year)=>{
        const url = `payroll/reports/summary/pdf`;
        const qs = { year };
        await download(url, `payroll_summary_${year}.pdf`, 'pdf', true, qs );
    }
    return downloadSummaryReport;
}

export const useDownloadParticularsReport = ()=>{
    const downloadParticularsReport = async (year, month)=>{
        const url = `payroll/reports/particulars/pdf`;
        const qs = { year, month };
        await download(url, `payroll_particulars_${year}_${month}.pdf`, 'pdf', true, qs);
    }
    return downloadParticularsReport;
}
